import React, { useEffect, useRef } from "react";
import {
  filterBy,
  CompositeFilterDescriptor,
} from "@progress/kendo-data-query";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  GridCustomHeaderCellProps,
  GridCustomCellProps,
} from "@progress/kendo-react-grid";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { PagerTargetEvent } from "@progress/kendo-react-data-tools";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import { Typography } from "@progress/kendo-react-common";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { LoadingPanel } from "../../../components/layout/Loading";
import AlertBox from "../../../components/common/AlertBox";
import { getDashboardTotalBooking } from "../services/dashboard.services";
import { formatIndianNumber } from "../../../_helper/helper";
import { useLocation } from "react-router-dom";

const TotalTourBooking: React.FC = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const pathNameArray = location?.pathname?.split("/")[2];
  const dateFilter = useAppSelector((state) => state.dashboard.dateFilter);

  useEffect(() => {
    const payload = {
      FromDate: dateFilter?.FromDate ? dateFilter?.FromDate : "",
      ToDate: dateFilter?.ToDate ? dateFilter?.ToDate : "",
    };
    dispatch(getDashboardTotalBooking(payload));
  }, [dateFilter]);

  return (
    <>
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 0 20px 0",
          }}
        >
          <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
            {pathNameArray === "totalpayments"
              ? "Total Payments"
              : "Ticket Bookings"}
          </Typography.h4>
        </GridLayoutItem>
        <GridLayoutItem>
          <TicketBookingGridComponent />
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

interface PageState {
  skip: number;
  take: number;
}

const initialDataState: PageState = { skip: 0, take: 10 };

const TicketBookingGridComponent: React.FC = () => {
  const gridRef = useRef<any>(null);

  const TotalBookingList = useAppSelector(
    (state) => state.dashboard.TotalBookingList
  );
  const loading = useAppSelector((state) => state.dashboard.loading);

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);
  const [page, setPage] = React.useState<PageState>(initialDataState);
  const [pageSizeValue, setPageSizeValue] = React.useState<
    number | string | undefined
  >();

  const pageChange = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent;
    const take =
      targetEvent.value === "All" ? TotalBookingList.length : event.page.take;

    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value);
    }
    setPage({
      ...event.page,
      take,
    });
  };

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
    setPage({ skip: 0, take: page.take });
  };
  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${props.index === 13 ? "locked-header" : ""}`}
    >
      {props.children}
    </HeaderThElement>
  );

  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };

  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  if (loading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <>
      {TotalBookingList && TotalBookingList.length ? (
        <KendoGrid
          className="responsive-table"
          style={{ maxHeight: "calc(100vh - 152px)" }}
          filterable={true}
          filter={filter}
          data={
            filter
              ? filterBy(TotalBookingList, filter).slice(
                  page.skip,
                  page.take + page.skip
                )
              : TotalBookingList.slice(page.skip, page.take + page.skip)
          }
          onFilterChange={handleFilterChange}
          skip={page.skip}
          take={page.take}
          total={TotalBookingList.length}
          pageable={{
            buttonCount: 5,
            pageSizes: [5, 10, 15, "All"],
            pageSizeValue: pageSizeValue,
            type: "input",
          }}
          onPageChange={pageChange}
          cells={{
            headerCell: HeaderCustomCell,
            data: MyDataCustomCell,
          }}
        >
          <Column field="VisitDate" title="Visit Date" width={150} />
          <Column field="Name" title="Name" width={200} />
          <Column field="MobileNo" title="Mobile No." width={150} />
          <Column field="EmailID" title="Email ID" width={300} />
          <Column field="City" title="City" width={200} />
          <Column
            field="NumberOfPax"
            title="No. Of Pax"
            width={150}
            cells={{
              data: (props: any) => (
                <td className="text-end">{props.dataItem?.NumberOfPax}</td>
              ),
            }}
          />
          <Column
            field="TotalCost"
            title="Total Cost"
            width={150}
            cells={{
              data: (props: any) => (
                <td className="text-end">
                  {props.dataItem?.TotalCost
                    ? formatIndianNumber(props.dataItem?.TotalCost)
                    : ""}
                </td>
              ),
            }}
          />
        </KendoGrid>
      ) : (
        <AlertBox />
      )}
    </>
  );
};

export default TotalTourBooking;
